import * as React from 'react';
import { MastheadPortalId } from '../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { LogMeetingNotes } from '../../containers/LogMeetingNotes';

export const AdminLogMeetingNotesPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='Log Meeting Notes' />
			</Portal>
			<LogMeetingNotes />
		</AdminDashboardPageLayout>
	);
};
